const PersonRoles = {
    default: 'default',
    employee: 'employee',
    anonymous: 'anonymous',
}

export { PersonRoles };